/**
 * Route for `sftp-scheduled-export`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SftpScheduledExportPage } from "../features/sftp-scheduled-export/SftpScheduledExportPage";

export const sftpScheduledExportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/sftp-scheduled-export",
	component: SftpScheduledExportPage,
});

export default sftpScheduledExportRoute;
